import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Config from "../../core/config";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import ConfirmButton from "../common/ConfirmButton";
import BackButton from "../common/BackButton";
import {useNavigate} from "react-router-dom";
import {showAlert} from "../../core/dialog";

const apiUrl = Config.apiUrl;

const PdvTableManager = () => {
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    const newEntity = {id: undefined, name: '', enabled: true};
    const [formData, setFormData] = useState(newEntity);

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prev) => ({...prev, [name]: type === 'checkbox' ? checked : value}));
    };

    async function makeQuery() {
        if (id) {
            try {
                const response = await makeRequest(apiUrl + '/api/tables/id=' + id, 'GET');
                setFormData(response);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else {
            setFormData({...newEntity, enabled: true});
        }
    }

    useEffect(() => { makeQuery(); }, [id]);

    function validateInputs() {
        if (!formData.name || formData.name === '') {
            showAlert('Preencha o campo nome.');
            return false;
        }
        return true;
    }

    async function saveEntity() {
        await makeRequest(apiUrl + '/api/tables', id ? 'PUT' : 'POST',
            {'Content-Type': 'application/json'}, JSON.stringify(formData));
    }

    const onConfirm = async () => {
        try {
            if (validateInputs()) {
                setLoading(true);
                await saveEntity();
                navigate('/pdv/tablelist');
            }
        } catch (error) {
            console.error('Error saving:', error);
            showAlert('Erro ao salvar.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="header-label">{formData.id > 0 ? 'Editar' : 'Cadastrar'} Mesa</div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Nome:</div>
                <input type="text" style={{width: '300px'}} value={formData.name} name="name" onChange={handleChange}/>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Habilitado:</div>
                <input type="checkbox" checked={formData.enabled !== undefined ? formData.enabled : true}
                       name="enabled" onChange={handleChange}/>
            </div>
            <ActionButtonsManagerView>
                <BackButton onClick={() => navigate(-1)}/>
                <ConfirmButton onClick={onConfirm}/>
            </ActionButtonsManagerView>
        </div>
    );
};

export default PdvTableManager;
